import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { Movement } from '#src/app/pages/petitionDetails/shared/types';

export function useFirstMovement(): Movement | undefined {
	const {
		data: {
			petition: { movementsConnection },
		},
	} = usePetitionDetailsPageData();

	return movementsConnection.nodes[0];
}
